import formSpaceHomeMain from './formSpaceHomeMain';
import formTagsExtendedEdit from './formTagsExtendedEdit';
import formTagsMainEdit from './formTagsMainEdit';
import formTagsPosterEdit from './formTagsPosterEdit';

export default {
  title: 'Space Manager Home',
  attributeName: 'wlproHome',
  getURL: 'space/appId/home',
  // createURL: 'tags',
  updateURL: 'space/appId',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: false,
  sessionParams: ['appId'],
  saveValueSessionParams: ['mainHubId',],
  formConfig: [formSpaceHomeMain],
  noArea: true,
  goBack: false,
  // reconfirmMessage:'Are you sure you want to save this overwritten tag?',
};
